import TextInput from './TextInput';

export default TextInput;